<template>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="151.8699951171875 -910.4100952148438 656.260009765625 838.5401000976562"
    fill="currentColor"
    class="icon-share"
  >
    <path
      d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h80q17 0 28.5 11.5T360-600q0 17-11.5 28.5T320-560h-80v400h480v-400h-80q-17 0-28.5-11.5T600-600q0-17 11.5-28.5T640-640h80q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-240q-17 0-28.5-11.5T440-360v-407l-36 36q-12 12-28 11.5T348-732q-11-12-11.5-28t11.5-28l104-104q6-6 13-8.5t15-2.5q8 0 15 2.5t13 8.5l104 104q11 11 11 27.5T612-732q-12 12-28.5 12T555-732l-35-35v407q0 17-11.5 28.5T480-320Z"
    />
  </svg>
</template>
